module.exports = "<select class=\"form-control\" (change)=\"onChange($event.target.value)\" >\n  <option *ngFor=\"let status of statuses\" value=\"{{status.status}}\" [selected]=\"status.status == activeStatus\" >{{status.name}}</option>\n</select>"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/user/user-status/user-status.component.html
// module id = ../../../../../angular/app/views/user/user-status/user-status.component.html
// module chunks = main